import { Button, Container, Modal, Table, Text } from "@mantine/core";
import { usePostApi } from "src/hooks";
import { Notification } from "src/utils/Notification";

interface Props {
  opened: boolean;
  close: () => void;
  refetch: () => void;
}

const RotationInfoModal = ({ opened, close, refetch }: Props) => {
  const { post } = usePostApi();
  
  const handleDeleteReport = async (rid: string) => {
    await post({
      request: "delete-report",
      body: { params: { rid } },
      onSuccess: () =>
        Notification(
          "Report removed",
          "Report has been deleted successfuly",
          "green",
        ),
    });
    refetch();
    close();
  };

  const rows = [1,2,3,4].map((element, index) => (
    <tr key={index}>
      <td>User name {index + 1}</td>
      <td>User rank</td>
    </tr>
  ));

  return (
    <Modal
      yOffset={"25dvh"}
      opened={opened}
      onClose={close}
      title="User email rotation">
      <div>
        <Text>There are users that are already in the system with that email, if you enable this user the these accounts will be marked as, on rotation.</Text>
        <Container my={20}>
            <Table>
                <thead>
                    <tr>
                    <th>User name</th>
                    <th>Rank</th>
                    </tr>
                </thead>
                <tbody>{rows}</tbody>
            </Table>
        </Container>
        <Text style={{textAlign:"center"}} py={5}>Are you sure you want to proceed ?</Text>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginTop: "15px",
          }}>
          <Button
            onClick={() => {
              close();
            }}>
            Cancel
          </Button>
          <Button
            color="green"
          >
            Yes
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RotationInfoModal;
